import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';
import { useQuestTypeList } from '@/modules/quest/type/model/list';
import { questService } from '@/services/quest';
import { useVuelidate } from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useQuestItemEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { questTypeOptions, fetchList: fetchQuestTypeOption } = useQuestTypeList();

    const model = reactive({
        id: route.params.itemId,
        name: null,
        typeId: null,
        game: 0,
        fromAvgGame: -1,
        toAvgGame: -1,
        fromGameBet: -1,
        toGameBet: -1,
        gameType: 0,
        reward: 0,
        adsBoost: 0,
        adsBoostRate: 100,
        canDelete: false,
        canDisable: true,
        canDisableNext: true,
        canEnable: false,
        canEnableNext: false
    });

    const validations = {
        name: { required },
        game: { required, integer, min: minValue(1) },
        reward: { required, integer, min: minValue(1) },
        adsBoost: { required, integer, min: minValue(0) },
        adsBoostRate: { required, integer, min: minValue(100) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => questService.item.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_QUEST.ITEM.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                questService.item.update(
                    model.id,
                    model.name,
                    model.game,
                    model.reward,
                    model.adsBoost,
                    model.adsBoostRate
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_QUEST.ITEM.INDEX })
        }),
        disable: crudAction.confirmAndDisable({
            request: () => questService.item.disable(model.id),
            onSuccess: fetch
        }),
        disableNext: crudAction.confirmAndDisable({
            request: () => questService.item.disableNext(model.id),
            onSuccess: fetch
        }),
        enable: crudAction.confirmAndEnable({
            request: () => questService.item.enable(model.id),
            onSuccess: fetch
        }),
        enableNext: crudAction.confirmAndEnable({
            request: () => questService.item.enableNext(model.id),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: () => questService.item.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_QUEST.ITEM.INDEX })
        })
    };

    onMounted(async () => {
        await fetchQuestTypeOption();
        await fetch();
    });

    return { model, v$, questTypeOptions, actions };
}
